import { render } from "./NotificationAudiencePreview.vue?vue&type=template&id=a152d466&scoped=true"
import script from "./NotificationAudiencePreview.vue?vue&type=script&lang=js"
export * from "./NotificationAudiencePreview.vue?vue&type=script&lang=js"

import "./NotificationAudiencePreview.vue?vue&type=style&index=0&id=a152d466&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a152d466"]])

export default __exports__